
import { Component, Prop, Vue } from "vue-property-decorator";

type OrganizationOption = {
    id: string;
    name: string;
    userId?: string | null;
    wallet?: {
        balance?: number | null;
    } | null;
    memberships?: Array<{
        role?: string | null;
    }>;
};

type OrganizationDisplay = {
    id: string;
    name: string;
    avatar: string;
    role: string;
    active: boolean;
};

@Component
export default class TranslationJobHeaderControls extends Vue {
    @Prop({ type: Array, default: () => [] })
    organizations!: OrganizationOption[];

    @Prop({ type: String, default: null })
    currentOrgId!: string | null;

    @Prop({ type: String, default: null })
    currentUserId!: string | null;

    @Prop({ type: Number, default: 0 })
    currentBalance!: number;

    @Prop({ type: Boolean, default: false })
    disabled!: boolean;

    @Prop({ type: Boolean, default: true })
    showCreate!: boolean;

    get currentOrg() {
        return this.organizations.find((org) => org.id === this.currentOrgId) ?? null;
    }

    get currentOrgName() {
        return this.getOrgDisplayName(this.currentOrg);
    }

    get currentOrgAvatar() {
        return this.getOrgAvatar(this.currentOrg);
    }

    get currentOrgRole() {
        return this.getOrgRole(this.currentOrg);
    }

    get ownedOrganizations() {
        if (!this.currentUserId) return [];
        return this.organizations.filter((org) => org.userId === this.currentUserId);
    }

    get memberOrganizations() {
        if (!this.currentUserId) return [];
        return this.organizations.filter((org) => org.userId !== this.currentUserId);
    }

    get ownedOrganizationsDisplay(): OrganizationDisplay[] {
        return this.ownedOrganizations.map((org) => ({
            id: org.id,
            name: this.getOrgDisplayName(org),
            avatar: this.getOrgAvatar(org),
            role: this.getOrgRole(org),
            active: org.id === this.currentOrgId,
        }));
    }

    get memberOrganizationsDisplay(): OrganizationDisplay[] {
        return this.memberOrganizations.map((org) => ({
            id: org.id,
            name: this.getOrgDisplayName(org),
            avatar: this.getOrgAvatar(org),
            role: this.getOrgRole(org),
            active: org.id === this.currentOrgId,
        }));
    }

    formatPoints(value: number) {
        return Math.ceil(value).toLocaleString();
    }

    getOrgAvatar(org?: OrganizationOption | null) {
        const name = this.getOrgDisplayName(org);
        return name.trim().slice(0, 1).toUpperCase() || "-";
    }

    getOrgDisplayName(org?: OrganizationOption | null) {
        const name = org?.name ?? "-";
        return this.$_(name);
    }

    getOrgRole(org?: OrganizationOption | null) {
        if (!org) return "-";
        if (this.currentUserId && org.userId === this.currentUserId) return "OWNER";
        const role = org.memberships?.[0]?.role;
        return role ? String(role) : "MEMBER";
    }
}
